import gsap from "gsap";
import { getTableRecordById, updateTableRecord } from "../../utils/api/tableApi";

export const EDIT_INITIAL_FORM = {
  Kampania: "",
  Klient: "",
  Link: "",
  Format: "",
  Kategoria: "",
};

const INFO_TYPE_SUCCESS = "Succes";
const INFO_TYPE_FAIL = "Fail";

const EDIT_SUCCESS_MESSAGE = "Udalo sie zedytowac!";
const EDIT_FAIL_MESSAGE = "Nie udalo sie zedytowac!";

const ERROR_STATUS_CODES = [400, 401];

const mapRecordToForm = (record = {}) => ({
  Kampania: record.Kampania || "",
  Klient: record.Klient || "",
  Link: record.Link || "",
  Format: record.Format || "",
  Kategoria: record.Kategoria || "",
});

export const hideEditModal = (modalRef) => {
  if (!modalRef?.current) return;

  gsap.to(modalRef.current, {
    opacity: 0,
    duration: 0.3,
    onComplete: () => {
      modalRef.current.style.display = "none";
      gsap.set(modalRef.current, { opacity: 1 });
    },
  });
};

export function createEditController({
  editID,
  choosenTable,
  getData,
  setItem,
  setLoading,
  setFormData,
  setInfoType,
  setInfo,
  modalRef,
}) {
  const loadRecord = async () => {
    if (!editID) return;

    try {
      setLoading(true);
      const response = await getTableRecordById(choosenTable, editID);
      const record = response?.data || null;

      setItem(record);
      setFormData(mapRecordToForm(record));
    } catch (error) {
      console.error(error);
      setItem(null);
    } finally {
      setLoading(false);
    }
  };

  const submitForm = async (formData) => {
    if (!editID) return false;

    try {
      const response = await updateTableRecord(choosenTable, editID, formData);

      if (response.status === 200) {
        setInfoType(INFO_TYPE_SUCCESS);
        setInfo(EDIT_SUCCESS_MESSAGE);
        await getData();
        hideEditModal(modalRef);
        return true;
      }

      if (ERROR_STATUS_CODES.includes(response.status)) {
        setInfoType(INFO_TYPE_FAIL);
        setInfo(EDIT_FAIL_MESSAGE);
        return false;
      }

      setInfoType(INFO_TYPE_FAIL);
      setInfo(EDIT_FAIL_MESSAGE);
      return false;
    } catch (error) {
      console.error(error);
      setInfoType(INFO_TYPE_FAIL);
      setInfo(EDIT_FAIL_MESSAGE);
      return false;
    }
  };

  return {
    loadRecord,
    submitForm,
    hideModal: () => hideEditModal(modalRef),
  };
}
